module.exports = __webpack_public_path__ + "media/images/new-ui-images/assign-form-icon-9ae6f16232dbf75c40c512291044f737.svg";